import { VehicleColorType } from '@/common/queries/selections/vehicleColor/vehicleColor.type';
import { InsuranceABV } from '@/common/types/SelectionOptions.type';
import { fetchApi } from '@/config/axiosSetting';

export const getVehicleColorFunction = (
  insurance: InsuranceABV,
  name?: string,
): Promise<VehicleColorType[]> => {
  return fetchApi.get('/selection_item/vehicle_color/wop_list/', {
    params: { insurance: insurance, name },
  });
};
